export default "__VITE_ASSET__RNTMAS8vSap0SvY08rMu8Q__"